import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruthruns3postPostSidecarRegisterResponseSchema = jsonObject
export type tcpscreentruthruns3postPostSidecarRegisterResponse = z.infer<typeof tcpscreentruthruns3postPostSidecarRegisterResponseSchema>
export const tcpscreentruthruns3postPostSidecarClaimResponseSchema = jsonObject
export type tcpscreentruthruns3postPostSidecarClaimResponse = z.infer<typeof tcpscreentruthruns3postPostSidecarClaimResponseSchema>
export const tcpscreentruthruns3postPostSidecarLeasesIdHeartbeatResponseSchema = jsonObject
export type tcpscreentruthruns3postPostSidecarLeasesIdHeartbeatResponse = z.infer<typeof tcpscreentruthruns3postPostSidecarLeasesIdHeartbeatResponseSchema>
export const tcpscreentruthruns3postPostSidecarLeasesIdResultResponseSchema = jsonObject
export type tcpscreentruthruns3postPostSidecarLeasesIdResultResponse = z.infer<typeof tcpscreentruthruns3postPostSidecarLeasesIdResultResponseSchema>
